import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";

if (document.querySelector('.variation_id')) {
    const targetNode = document.querySelector('.variation_id');

    const observer = new MutationObserver(getVariationInfo);
    observer.observe(targetNode, { attributes: true });
}

function getVariationInfo (mutationsList) {
    for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            const variations_info = JSON.parse(document.querySelector('.variations_form').getAttribute('data-product_variations'));
            const variation_info = variations_info.filter(item => item.variation_id === parseInt(mutation.target.value)).length > 0 ? variations_info.filter(item => item.variation_id === parseInt(mutation.target.value))[0] : {};
            const variation_id = variation_info.variation_id;
            let variation_price_html = '';

            console.log(variation_id);

            if (variation_id) {
                document.querySelector('.add_to_cart_button').setAttribute('data-product_id', variation_id);
                document.querySelector('.add_to_cart_button').setAttribute('value', variation_id);
                document.querySelector('.fast_buy')?.setAttribute('href', `${document.querySelector('[name="checkout_url"]').value}?add-to-cart=${variation_id}`);

                document.querySelector('.fast_buy')?.classList?.remove('disabled');
                document.querySelector('.add_to_cart_button').classList.remove('disabled');

                variation_price_html = variation_info.price_html;
            }
            else {
                document.querySelector('.fast_buy')?.classList?.add('disabled');
                document.querySelector('.add_to_cart_button').classList.add('disabled');

                variation_price_html = document.querySelector('[name="product_parent_price"]').value;
            }

            document.querySelector('.rr-shop-details__price .woocs_price_code').innerHTML = variation_price_html;
        }
    }
}

document.body.addEventListener('change', function(event) {
    if (event.target.hasAttribute('name') && event.target.getAttribute('name') === 'quantity') {
        const el = event.target;
        document.querySelector('.add_to_cart_button')?.setAttribute('data-quantity', el.value);
    }
});

document.querySelector('.my-account > a')?.addEventListener('click', function (e) {
    e.preventDefault();
    const parent_el = this.closest('.my-account');

    this.classList.toggle('open');
    parent_el.querySelector('.my-account-dropdown').classList.toggle('open');
});

document.querySelectorAll('.woocommerce-error li, .woocommerce-message').forEach(item => {
    Toastify({
        text: item.textContent,
        duration: 3000,
        close: true,
        stopOnFocus: true,
        style: {
            background: document.querySelector('[name="rr_notifications_error"]'),
        },
    }).showToast();
});

jQuery(document.body).on('added_to_cart', function(event, fragments, cart_hash, button) {
    const el_text = document.querySelector('[name="product_added_to_cart_text"]').value;

    Toastify({
        text: el_text,
        duration: 3000,
        close: true,
        stopOnFocus: true,
        style: {
            background: document.querySelector('[name="rr_notifications_success"]'),
        },
    }).showToast();
});
